// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Hqho4","title":"Info_title__2fcJL","links":"Info_links__8xO3y","link":"Info_link__2zKDa","logo":"Info_logo__jm0JR"};